<template>
    <div>
        <div
            class="card overflow-hidden p-3 m-0"
            :class="{'interactive-card pointer': donationsActive}"
            @click.prevent="openRegLink">
            <div
                class="grid-container"
                :class="{'no-image': !hasImage}">
                <div
                    v-if="project.image"
                    class="grid-area-image">
                    <ProjectImage :images="project.image ? [project.image] : []" />
                </div>
                <div class="grid-area-info">
                    <div class="d-flex flex-column gap-3 h-100 align-items-sm-start align-items-center">
                        <div class="d-flex flex-column align-items-sm-start align-items-center">
                            <h1 class="mb-0">
                                {{ project.name }}
                            </h1>
                            <span>
                                <font-awesome-icon icon="hashtag" />
                                {{ project.projectNumber }}
                            </span>
                        </div>
                        <div
                            v-if="project.donationGoal"
                            class="w-100">
                            <ProjectDonationProgress
                                :donation-goal="project.donationGoal"
                                :donation-sum="project.donationSum"
                                :currency="currency" />
                        </div>
                        <div
                            v-if="donationsActive"
                            class="donation-active-hint">
                            Jetzt spenden!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectImage from "./ProjectImage";
import ProjectDonationProgress from "./ProjectDonationProgress";

export default {
    name: "ProjectOverview",
    components: {ProjectDonationProgress, ProjectImage},
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    computed: {
        timeSpan() {
            if (!this.project.startDate && !this.project.endDate) return "Dauerhaft"
            let startMoment = null
            let endMoment = null
            if (this.project.startDate) startMoment = this.moment(this.project.startDate)
            if (this.project.endDate) endMoment = this.moment(this.project.endDate)
            return "" + (startMoment ? ("Ab " + this.$d(startMoment, 'dateLong') + " ") : "")
                + (endMoment && !(startMoment && startMoment.isSame(endMoment, 'day')) ? ("Bis " + this.$d(endMoment, 'dateLong')) : "")
        },
        currency() {
            return this.project?.organizer?.currencyCode || "EUR"
        },
        hasImage() {
            return !!this.project?.image
        },
        donationsActive() {
            return this.project?.onlineDonations
        }
    },
    methods: {
        async openRegLink() {
            const encryptedPersonalData = await this.$store.dispatch('registration/getEncryptedPersonalData')
            const url = new URL(this.project.donationLink)
            if (encryptedPersonalData) url.searchParams.set('donorData', encryptedPersonalData)
            window.open(url, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.grid-container {
    display: grid;
    gap: map.get($spacers, 4);
    grid-template-columns: 1fr;
    grid-template-rows: 100px auto;
    grid-template-areas:
    "image"
    "info";

    &.no-image {
        grid-template-rows: auto;
        grid-template-areas:
            "info";
    }
}

@include media-breakpoint-up(sm) {
    .grid-container {
        grid-template-columns: 2fr;
        grid-template-rows: 100px auto;
        grid-template-areas:
            "image"
            "info";


        &.no-image {
            grid-template-rows: auto;
            grid-template-areas:
              "info";
        }
    }
}

@include media-breakpoint-up(md) {
    .grid-container {
        grid-template-columns: 1fr 3fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image info";

        &.no-image {
            grid-template-columns: auto;
            grid-template-areas:
                  "info";
        }
    }

}


.grid-area-image {
    grid-area: image;
    margin: map.get($spacers, -3);

    @include media-breakpoint-up(md) {
        margin-right: 0;
    }
}

.grid-area-info {
    grid-area: info;
}

@include media-breakpoint-up(sm) {
    .price-divider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: calc(#{map.get($spacers, -4)} / 2);
        border-image: linear-gradient(to bottom, $white, $border-color 30%, $border-color 70%, $white) 1 100%;
        border-left-width: 1px;
        border-left-style: solid;
    }
}

.donation-active-hint {
    white-space: nowrap;
    background-color: transparent;
    color: $primary;
    border-radius: .25rem;
    border: 1px solid $primary;
    transition: all $iframe-transition-duration ease-out;
    letter-spacing: 0.025em;
    font-size: 0.875rem;
    padding: 0.625rem 1.25rem;
    font-weight: 600;
}

.interactive-card {
    cursor: pointer;
    transition-property: box-shadow, transform;
    transition-duration: $iframe-transition-duration;
    transition-timing-function: cubic-bezier(0.16, 1, 0.29, 0.99);

    &:hover {
        box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.18), 0 1px 2px rgba(0, 0, 0, 0.1);
        transform: translate3d(0, -3px, 0);

        .donation-active-hint {
            background-color: $primary;
            color: white;
        }
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: transparent;
        transition: background-color $iframe-transition-duration ease-out;
    }

    &:hover::before {
        background-color: rgba($gray-800, 0.05);
    }
}
</style>
